import { Vue, Component, Watch } from 'vue-property-decorator';

@Component({})
export default class PopupPluginDownload extends Vue {
  @Watch('$route')
  onRouteChange() {
    this.closeChromeExtensionPopup();
  }

  closeChromeExtensionPopup() {
    // Logic to close the Chrome extension popup
    const modalElement = document.getElementById('go-modal-event-plugin');
    if (modalElement) {
      // @ts-ignore
      window.$(modalElement).modal('hide');
    }
  }
}
